module.exports = __webpack_public_path__ + "static/media/icon-win.c2df0ab6.png";